import RouterLocale from '@/components/router/RouterLocale';


export default [{
  path: '/:locale',
  component: RouterLocale,
  children: [{ // Publicly indexed (Public) views
    path: '',
    component: () => import('../layouts/Default'),
    children: [{
      path: '',
      name: 'Home',
      component: () => import('../views/Home'),
    }, {
      path: 'informationen-käufer',
      name: 'BuyerInformation',
      component: () => import('../views/BuyerInformation'),
    }, {
      path: 'informationen-verkäufer',
      name: 'SellerInformationFR',
      component: () => import('../views/SellerInformation'),
    }, {
      path: 'vendeur-informations',
      name: 'SellerInformationDE',
      component: () => import('../views/SellerInformation'),
    }, {
      path: 'vehicle-seller',
      name: 'SellerInformationEN',
      component: () => import('../views/SellerInformation'),
    }, {
      path: 'preise',
      name: 'PricingInformation',
      component: () => import('../views/PricingInformation'),
    }, {
      path: 'vehicle/:vehicleId/:buyerId',
      name: 'VehicleDetails',
      component: () => import('../views/VehicleDetails'),
      props: true,
    }],
  }],
}, {
  path: '*',
  redirect: { name: 'Home' },
}];
